import confetti from 'canvas-confetti';

/** Brand confetti, read from design tokens so it follows the theme. */
function palette(): string[] {
  const css = getComputedStyle(document.documentElement);
  const tokens = ['--primary', '--accent', '--success', '--warning'];
  const colors = tokens
    .map((t) => css.getPropertyValue(t).trim())
    .filter(Boolean)
    .map((v) => (v.startsWith('#') || v.startsWith('rgb') || v.startsWith('hsl') ? v : `hsl(${v})`));
  // canvas-confetti needs hex; convert via a canvas.
  const ctx = document.createElement('canvas').getContext('2d');
  const hex = colors.map((c) => { if (!ctx) return c; ctx.fillStyle = c; return ctx.fillStyle; });
  return [...hex, '#ffffff'];
}

const reduced = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

/** A small, quick burst when one Desk Setup step is finished. */
export function celebrateStep() {
  if (reduced()) return;
  const colors = palette();
  confetti({ particleCount: 70, spread: 75, startVelocity: 38, origin: { y: 0.35 }, colors, zIndex: 9999, disableForReducedMotion: true });
}

/** A longer shower from the top of the screen when Desk Setup is complete. */
export function celebrateGraduation() {
  if (reduced()) return;
  const colors = palette();
  const end = Date.now() + 3500;
  const frame = () => {
    confetti({ particleCount: 6, angle: 270, spread: 160, startVelocity: 15, gravity: 0.8, ticks: 320,
      origin: { x: Math.random(), y: -0.05 }, colors, zIndex: 9999, disableForReducedMotion: true });
    if (Date.now() < end) requestAnimationFrame(frame);
  };
  frame();
}
